import React, { useEffect, useState } from "react";
import { Undo2, ChevronDown } from "lucide-react";
import api, { formatMoney, formatNumber } from "../../lib/api";

const fecha = (v) => (v ? new Date(v).toLocaleDateString("es-ES") : "—");

export function StockDevolver({ lab, seg, familia }) {
  const [d, setD] = useState(null);
  const [abierto, setAbierto] = useState(false);

  useEffect(() => {
    setD(null);
    api.get("/lab-analisis/devolver", { params: { laboratorio: lab, segment: seg, familia: familia || undefined } })
      .then((r) => setD(r.data)).catch(() => setD({ items: [] }));
  }, [lab, seg, familia]);

  if (!d) return null;
  if (!d.items.length) return <div className="card p-5 text-sm text-slate-500" data-testid="la-devolver-vacio">No hay stock antiguo para devolver: nada sin ventas que entrara hace más de 2 años.</div>;
  return (
    <div className="card p-6 border-l-4 border-l-red-500" data-testid="la-devolver">
      <div className="flex items-start justify-between gap-4 flex-wrap">
        <div>
          <h3 className="font-display text-lg font-bold flex items-center gap-2"><Undo2 size={18} className="text-red-600" /> Stock para devolver</h3>
          <p className="text-xs text-slate-500">Sin ventas y con última entrada anterior al {fecha(d.desde)} (más de 2 años). Va al final del PDF del pedido (y en una hoja aparte del Excel) para negociarlo con el delegado.</p>
        </div>
        <div className="text-right">
          <div className="font-display text-2xl font-extrabold text-red-600" data-testid="la-devolver-total">{formatMoney(d.total_importe)}</div>
          <div className="text-xs text-slate-500">{formatNumber(d.items.length)} productos · {formatNumber(d.total_uds)} uds · valor a coste</div>
        </div>
      </div>
      <button onClick={() => setAbierto((v) => !v)} className="mt-3 text-sm font-semibold text-sky-700 inline-flex items-center gap-1" data-testid="la-devolver-toggle">
        {abierto ? "Ocultar productos" : "Ver productos"} <ChevronDown size={15} className={"transition-transform " + (abierto ? "rotate-180" : "")} />
      </button>
      {abierto && (
        <div className="overflow-x-auto mt-3 max-h-[420px] overflow-y-auto">
          <table className="w-full text-sm" data-testid="la-devolver-tabla">
            <thead className="sticky top-0 bg-white"><tr className="text-left text-[11px] uppercase tracking-wider text-slate-500 border-b">
              <th className="py-2 pr-3">Producto</th><th className="num">Stock</th><th className="num">Últ. venta</th><th className="num">Últ. entrada</th><th className="num">Coste ud.</th><th className="num">Importe</th></tr></thead>
            <tbody>
              {d.items.map((r) => (
                <tr key={r.cn} className="border-b border-slate-100" data-testid={`la-devolver-linea-${r.cn}`}>
                  <td className="py-2 pr-3"><div className="font-semibold">{r.descripcion}</div><div className="text-[11px] text-slate-400">CN {r.cn} · {r.familia}</div></td>
                  <td className="num">{formatNumber(r.stock)}</td><td className="num">{fecha(r.u_salida)}</td><td className="num">{fecha(r.u_entrada)}</td>
                  <td className="num">{formatMoney(r.coste)}</td><td className="num font-semibold text-red-600">{formatMoney(r.importe)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
